import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import 'primeflex/primeflex.css';

const Home = ({Auth}) => {
  const navigate = useNavigate();
console.log(Auth);
  const pagesUsers = [
    {
      title: "Clientes",
      description: "",
      path: "/empleados/listado",
      label: "Ver empleados",
      icon: "pi pi-users",
      color: "bg-blue-100 text-blue-800"
    },
    {
      title: "Productos / Servicios",
      description: "",
      path: "/empleados/listado",
      label: "Ver empleados",
      icon: "pi pi-users",
      color: "bg-blue-100 text-blue-800"
    }
    ,
    {
      title: "Facturas en el mes",
      description: "",
      path: "/empleados/listado",
      label: "Ver empleados",
      icon: "pi pi-users",
      color: "bg-blue-100 text-blue-800"
    }
    ,
    {
      title: "Facturas pendientes de pago",
      description: "",
      path: "/empleados/listado",
      label: "Ver empleados",
      icon: "pi pi-users",
      color: "bg-blue-100 text-blue-800"
    }
  
  ];

  return (
    <div className="p-4">
      <h1 className="mb-4 text-2xl font-bold">Bienvenido    </h1>
      <Card>

      </Card>
      <h5></h5>
      <div className="grid">
        {pagesUsers.map((page, idx) => (
          <div key={idx} className="col-12 md:col-4">
            <Card className="card p-0 overflow-hidden flex flex-column">
              <div className={`flex items-center gap-2 text-lg font-bold mb-2 p-2 border-round ${page.color}`}>
                <i className={page.icon}></i>
                {page.title}
              </div>
              <p className="text-gray-700 mb-3">{page.description}</p>
              
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
